// @flow
import gql from "graphql-tag"
import type { Mutation } from "common/graphql/types"
import type { ID } from "data/enums/types"
import { getUserQuery } from "data/user/graphql/queries"
import type { SubscriptionUpdateInput } from "../types"

export const createSubscriptionMutation: Mutation<{||}> = {
  gql: gql`
    mutation createSubscriptionMutation($input: CreateSubscriptionInput) {
      subscription {
        create(input: $input) {
          id
        }
      }
    }
  `,
  refetch: [getUserQuery],
}

export const cancelSubscriptionMutation: Mutation<{||}> = {
  gql: gql`
    mutation cancelSubscriptionMutation {
      subscription {
        cancel {
          id
        }
      }
    }
  `,
  refetch: [getUserQuery],
}

export const updateSubscriptionMutation: Mutation<{|
  input: SubscriptionUpdateInput
|}> = {
  gql: gql`
    mutation updateSubscriptionMutation($input: SubscriptionUpdateInput) {
      subscription {
        update(input: $input) {
          id
        }
      }
    }
  `,
  refetch: [getUserQuery],
}

export const applyPromoCodeMutation: Mutation<{|
  reservationId: ID,
  code: string,
|}> = {
  gql: gql`
    mutation applyPromoCodeMutation($code: String!, $userId: Int!) {
      reservation {
        assignPromocode(code: $code, userId: $userId) {
          id
        }
      }
    }
  `,
}



// WEBPACK FOOTER //
// ./src/data/subscriptions/graphql/mutations.js